import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const NavbarTabs = ({ routes = [] }) => (
  <nav className="navbar-tabs">
    <ul>
      {routes.map(
        ({ name, path, hidden }) =>
          !hidden && (
            <li key={name}>
              <NavLink to={path} className={({ isActive }) => (isActive ? 'is-active' : '')}>
                {name}
              </NavLink>
            </li>
          ),
      )}
    </ul>
  </nav>
)

NavbarTabs.propTypes = {
  routes: PropTypes.array,
}

export default NavbarTabs
